import { storeActions } from "./store.action";
import { dashboardService } from "../../services";
import { custom, success } from "./actionsUtilities";
import {
  customToast,
  handleMapInvHistoryForSalesGraph,
} from "../../shared/utility";
import {
  toastType,
  toastMessages,
  systemConstants,
  deviceConstants,
  globalConstants,
  dashboardConstants,
  EMPTY_STRING,
} from "../../constants";

//-------Get get at a glance
const getAtAGlance = (
  selectedStore,
  start,
  end,
  category,
  productType,
  duration,
  screenName,
  companyId
) => {
  return (dispatch) => {
    dispatch(
      custom(
        dashboardConstants.GET_AT_A_GLANCE,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    dashboardService
      .getAtAGlance(
        selectedStore,
        start,
        end,
        category,
        productType,
        duration,
        screenName,
        companyId
      )
      .then(
        (response) => {
          dispatch(
            success(
              {
                ...(response || {}),
                saleInventoryHistory: response?.saleInventoryHistory || [],
              },
              dashboardConstants.GET_AT_A_GLANCE
            )
          );
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            dashboardConstants.GET_AT_A_GLANCE,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//-------Get store stats
const getStoreStats = (start, end) => {
  return (dispatch) => {
    dispatch(
      custom(deviceConstants.GET_ALL_DEVICES, systemConstants.SPINNER_ACTIVATE)
    );
    dashboardService
      .getStoreStats(start, end)
      .then(
        (response) => {
          dispatch(success(response || [], deviceConstants.GET_ALL_DEVICES));
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            deviceConstants.GET_ALL_DEVICES,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//-------Get store transaction history
const getStoreTransactionHistory = (
  storeId,
  type,
  start,
  end,
  duration,
  companyId
) => {
  return (dispatch) => {
    dispatch(
      custom(
        dashboardConstants.GET_STORE_TRANSACTION_HISTORY,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    dashboardService
      .getStoreTransactionHistory(
        storeId,
        type,
        start,
        end,
        duration,
        companyId
      )
      .then(
        (response) => {
          dispatch(
            success(response || [], dashboardConstants.GET_STORE_HISTORY)
          );
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            dashboardConstants.GET_STORE_HISTORY,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//-------Get store transaction history
const getStatsByCategory = (selectedStore, type, start, end) => {
  return (dispatch) => {
    dispatch(
      custom(deviceConstants.GET_ALL_DEVICES, systemConstants.SPINNER_ACTIVATE)
    );
    dashboardService
      .getStatsByCategory(selectedStore, type, start, end)
      .then(
        (response) => {
          dispatch(success(response || [], deviceConstants.GET_ALL_DEVICES));
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            deviceConstants.GET_ALL_DEVICES,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//-------Get store transaction history
const editPurchasingPower = (storeId, data) => {
  return (dispatch) => {
    dispatch(
      custom(
        dashboardConstants.UPDATE_PUCHASING_POWER,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    dashboardService
      .editPurchasingPower(storeId, data)
      .then(
        (response) => {
          customToast(
            toastMessages.STORE_PURCHASING_POWER_UPDATED,
            toastType.SUCCESS
          );
          dispatch(storeActions.getStores(EMPTY_STRING));
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            dashboardConstants.UPDATE_PUCHASING_POWER,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const setOutletToastFalse = (storeId, macAddress) => {
  return (dispatch) => {
    dispatch(success(null, dashboardConstants.DISPLAY_OUTLET_TOAST));
    dispatch(
      custom(
        dashboardConstants.UPDATE_MAC_ADDRESS_ACCESSED_LIST,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    dashboardService
      .updateMacAddressAccessedList(storeId, macAddress)
      .then(
        (response) => {
          dispatch(
            success(
              response || [],
              dashboardConstants.UPDATE_MAC_ADDRESS_ACCESSED_LIST
            )
          );
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            dashboardConstants.UPDATE_MAC_ADDRESS_ACCESSED_LIST,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//-------Export Authentication Actions
export const dashboardActions = {
  getAtAGlance,
  getStoreStats,
  getStatsByCategory,
  getStoreTransactionHistory,
  editPurchasingPower,
  setOutletToastFalse,
};
